// Importing book covers for different series

// Prankster Prince covers
import PP1cover from "../assets/Thony1-COVER.jpg";
import PP2cover from "../assets/Thony2-COVER.jpg";
import PP3cover from "../assets/Thony3-COVER.jpg";
import PP4cover from "../assets/Thony4-COVER.jpg";
import PP5cover from "../assets/Thony5-COVER.jpg";
import PP6cover from "../assets/PP6-COVER.jpg";

// Prankster Prince blackblerbs
import PP1backblurb from "../assets/Thony1-Back-Blurb.jpg";
import PP2backblurb from "../assets/Thony2-Back-Blurb.jpg";
import PP3backblurb from "../assets/Thony3-Back-Blurb.jpg";
import PP4backblurb from "../assets/Thony4-Back-Blurb.jpg";
import PP5backblurb from "../assets/Thony5-Back-Blurb.jpg";
import PP6backblurb from "../assets/Thony6-Back-Blurb.jpg";

// Chronicles of Ilseador covers
import CoI1cover from "../assets/CoI1-COVER.jpg";
import CoI2cover from "../assets/CoI2-COVER.jpg";
import CoI3cover from "../assets/CoI3-COVER.jpg";
import CoI4cover from "../assets/CoI4-COVER-title.jpg";
import CoI5cover from "../assets/CoI5-COVER.jpg";
import CoI6cover from "../assets/CoI6-COVER.jpg";
import CoI7cover from "../assets/CoI7-COVER-PLACEHOLDER.jpg";
import CoI8cover from "../assets/CoI8-COVER-PLACEHOLDER.jpg";
// Chronicles of Ilseador backblurbs
import CoI1backblurb from "../assets/CoI1-Back-Blurb.jpg";
import CoI2backblurb from "../assets/CoI2-Back-Blurb.jpg";
import CoI3backblurb from "../assets/CoI3-Back-Blurb.jpg";
import CoI4backblurb from "../assets/CoI4-Back-Blurb.jpg";
import CoI5backblurb from "../assets/CoI5-Back-blurb.jpg";
import CoI6backblurb from "../assets/CoI6-Back-blurb.jpg";
import CoI7backblurb from "../assets/CoI7-Back-blurb.jpg";

// Knightess of the Realm covers
import KotR1cover from "../assets/KotRP-KotR1-EPUB-cover-fromID.jpg";
import KotR2cover from "../assets/KotRP2-HJ1-EPUB-cover-fromID.jpg";
import KotR3cover from "../assets/KotRP3-HJ2-EPUB-cover-fromID.jpg";
import KotR4cover from "../assets/KotRP4-HJ3-EPUB-cover-fromID.jpg";
import KotR5cover from "../assets/KotRMain-1-SDM1-EPUB-cover-fromID.jpg";
import KotRFoTcover from "../assets/KotRP-FoT-EPUB-cover-fromID.jpg";
import KotRSCcover from "../assets/KotRP-SC-EPUB-cover-fromID.jpg";
import KotR6cover from "../assets/KotRMain-2-SDM2-EPUB-cover-fromID.jpg";
import KotR7cover from "../assets/KotRMain-3-SDM3-EPUB-cover-fromID.jpg";
import KotRMain4cover from "../assets/KotRMain-4-WoS-1-EPUB-cover-fromID.jpg";
import KotRPOotWcover from "../assets/KotRP-OotW-EPUB-cover-fromID.jpg";
// Knightess of the Realm backblurbs
import KotR1backblurb from "../assets/KotR1-Back-Blurb.jpg";
import KotR2backblurb from "../assets/KotR2-Back-Blurb.jpg";
import KotR3backblurb from "../assets/KotR3-Kalapula-HJ2-Back-Blurb.jpg";
import KotR4backblurb from "../assets/KotR4-HJ3-Back-Blurb.jpg";
import KotR5backblurb from "../assets/KotR5-SDM1-back-blurb.jpg";
import KotRFotbackblurb from "../assets/KotRP-FoT-Back-Blurb.jpg";
import KotRSCbackblurb from "../assets/KotRP-SC-Back-Blurb.jpg";
import KotR6backblurb from "../assets/KotR6-SDM2-back-blurb.jpg";
import KotR7backblurb from "../assets/KotR7-SDM3-back-blurb.jpg";
import KotRPOotWbackblurb from "../assets/KotR-Preq-OotW-Back-Blurb.jpg";
// Knightess of the Realm series banners
import SDMseriesBanner from "../assets/KotR-SDm-banner-with-books.jpg";
import HJseriesBanner from "../assets/KotR-HJ-banner-with-books.jpg";
import SPseriesBanner from "../assets/KotR-standalone-prequels-banner-with-books.jpg";
import WotSseriesBanner from "../assets/KotR-WoS-banner-with-book.jpg";


// ContemporaryRomance covers
import JoScover from "../assets/Jack-of-Spades-cover.jpg";

// ContemporaryRomance Backblurbs
import JoSbackblurb from "../assets/JoS-backblurb.jpg";

// Books for different series
export  const PPBooks = [
    { title: "Book one of the Prankster Prince: Thony and the Much-Anticipated Adventure",
      link:"PP1",
      image: PP1cover,
      backimage: PP1backblurb,
      shopifyProductId:   "9060947394811",// this and the line below define the book for shopify
      shopifyComponentId: "1752681824928",
      DescriptionTitle: "Can't a guy just get a break?",
      Description: `
<em>“Twice in one</em> day, <em>Thony?</em>”
<em>Even Princess Joanna's ever-patient tone sounded exasperated.
“What are you trying to do? Get Papa to keep you from ever seeing the light of day again? At this rate even Master Eswith will run out of protocol lessons.”</em>

“Um, no...?” She'd phrased it as a question, but Thony had the feeling it was rhetorical.

“And now you're involving the <em>servants</em> in your pranks again?” And <em>that</em> was disappointment, and if there was anyone whom Thony actually <em>cared</em> about not disappointing, it was his eldest sister.

“It wasn't a prank! The frog just sort of... escaped. And I knocked over her bucket. And then she helped catch it.” Which was all true, if slightly out of order. And definitely gave the impression that the frog had been <em>his</em> to start, rather than that <em>he</em> had been the victim of the <em>girl's</em> prank.

There didn't seem to be any good way out of this one. Thony looked at his feet. The servant girl had the frog, so he couldn't even pretend he was looking at it.
<em>Everyone in the castle tended to assume that, if there was something crazy going on, he was probably the cause of it.

To be fair, they were usually right.

And it was his honor and his privilege to liven things up a little.

Even if it</em> did <em>extend those interminable lessons with Master Eswith.</em>`,
      backblurb: `It wasn't fair.
Princes were supposed to go on adventures.
Instead, Thony's older sisters had gone off on The Quest and Left Him Behind. In Aldyrwald, of all places. I mean, yeah, it was their home and Thony was Crown Prince and all, but seriously? Aldyrwald was the boringest, most insignificant place in the world. In any world.
And Thony's efforts to “liven things up a little” are always so completely underappreciated.

Things start looking up with the arrival of Amanita, a mysterious foreign girl who also likes to play pranks, but refuses to share anything about her past. Befriending her – and saving her from the consequences of her own hot temper – somehow lead to Thony getting treated as more than just a boy.

But now his entirely unmysterious parents, Queen Annabel and King Bill, are acting like there's some Deep Dark Secret...
...and that it has something to do with Thony...`
     },
    { title: "Book two of the Prankster Prince: Thony Goes Astray! (in the Deep, Dark, and Dangerous Fairy Wood)", 
      link: "PP2-R",
      image: PP2cover,
      backimage: PP2backblurb,
      shopifyProductId:   "9061240176891",// this and the line below define the book for shopify
      shopifyComponentId: "1752703981026",
      DescriptionTitle: "AW, c'mon... we just made it into the Fairy Wood!",
      Description: `
<em><strong>“Silverfoot’s trembling. Something’s wrong.” He looked at Amanita.
“Could it be wolves?”</em></strong>

The trees around them – which were already larger than any that the young prince had ever seen before – seemed to loom in and cut off the light filtering down through their leaves even more than they had been. That… had to be all his imagination, though… right? Even if his dapple-grey gelding, Silverfoot, was shaking from nose to tail.

Amanita looked around with an expression that was now shading over into concern. Her short, bushy hair flopped a little as she turned sharply from side to side, peering into the green shadows of the forest. Twinklestar, the unicorn she was riding, looked around with what might be equine trepidation as well.

“Can’t Twinklestar <em>tell</em> you the problem?” Thony asked urgently, leaning forwards to try to give Silverfoot a better caress.

The girl shook her head, looking rather red around the ears. “We’re not <em>bonded,</em> so I can’t understand him in <em>words.</em>”

If the unicorn was upset, Silverfoot <em>was</em> terrified. Thony was beginning to worry that the gelding’s reaction would switch from half-paralyzed with fear to–

Oh, damn.

It was unfortunate that horses were trained to interpret a rider hunching into their backs as a signal to go <em>faster</em>. Because the only way to stay aboard a terrified horse that was plunging through a forest – instead of getting knocked off by low hanging branches – was to get as close as possible to the horse’s back.

Thony had just barely the concentration left to hear Amanita’s frustrated shout about this <em>not</em> being the right path. Silverfoot wasn’t following anything resembling a <em>path.</em>`,
      backblurb: `Running away from home in order to save his kingdom was a Gallant sort of thing for a Crown Prince to do. A self-sacrificing sort of thing. Maybe even a brave sort of thing.
Definitely Proper Princely Behavior.
Right?
And there should be some pretty awesome adventures as Thony looks for his princess (whom he’s too young to marry yet anyways, so there’s plenty of time before any gross stuff like that). 
And he’s starting out in the Fairy Wood which has all sorts of amazing and scary stories about it. Other people have all sorts of adventures in there.
Unfortunately, Thony’s adventure also involves an annoyingly superior stable-girl (his best friend, **sigh**), a grumpy unicorn, and an all-too-easily-freaked-out horse…`
     },
    { title: "Book three of the Prankster Prince: So You Want to Be a Hero?", 
      link: "PP3-R",
      image: PP3cover,
      backimage: PP3backblurb,
      shopifyProductId:   "9061252727035",// this and the line below define the book for shopify
      shopifyComponentId: "1752704927453",
      DescriptionTitle: "Isn't ONE small crazy girl enough?",
      Description:`
Neither of them noticed the package of trouble hurtling towards them until Amanita was extracting herself from under a jumble of girl, longbow, and brilliantly colored arrows that seemed to have spilled everywhere.

“Ooops,” said the new girl without a great deal of regret. She looked up at them with a certain wide-eyed innocence that Thony couldn’t help but feel was a bit of a put-on. Her leather jerkin was criss-crossed by a shoulder sheathe for a rather long sword, considering her size, that she was trying to untangle from her longbow and quiver.

“Don’t you believe in looking where you’re going?” Amanita demanded irritably.

“Usually,” the girl replied. “Sometimes. Um... <em>occasionally?</em>”

The greasy-seeming horse-dealer from earlier in the morning was also bearing down on them, his face furious.

Amanita’s gaze narrowed as she looked between the new girl and the new arrivals.

“What’s the matter here?” she demanded.

“That <em>girl</em> just released all me stock,” the greasy guy snarled. “She’s goin’ t’pay for this trouble!”

Amanita looked over her shoulder. “Did you really do that?”

The girl shuffled her feet and looked down – to hide a self-satisfied smirk, Thony rather thought.

“Eh... heh-heh-heh-heh-heh,” she chuckled uncomfortably, but didn’t deny it.`,
      backblurb:`Thony’s adventure is not going at all the way he had anticipated.
First off, he’s become a unicorn-maiden and is stuck wearing a dress, of all things.
Second of all, he’s stuck in a war-zone where an Evil Wizard is assembling an army.
And finally, the fairy prince Puck, who had agreed to see Thony and Amanita safely to her faraway homeland has disappeared.

To make matters worse, it appears that the Evil Wizard is coming to the dusty little town he and Amanita are sheltering in. It’s beginning to look like the only option that the two of them have is to deal with the situation themselves.

But surely just a couple of kids – even accomplished pranksters like Thony and Amanita – can’t possibly accomplish much against an Evil Wizard and his army…
…no, that might take three kids.`
     },
    { title: "Book four of the Prankster Prince: How Thony Stopped a War(and Saved a Friendship)", 
      link: "PP4-R",
      image: PP4cover,
      backimage: PP4backblurb,
      shopifyProductId:   "9061364760827",// this and the line below define the book for shopify
      shopifyComponentId: "1752715288213",
      DescriptionTitle: "RATS?!?!",
      Description:`
<em>“EEEEeeeek!”</em>
Amanita hid quickly to avoid being seen by someone running by – then peeked out as a sergeant and captain in Raven-soldier colors came out of a door down the hall.

“You realize you’ve roused the entire garrison, Captain Fayorn,” the sergeant growled. “I can’t imagine His Sorcerousness is going to be particularly forgiving that you disturbed their rest because of a <em>mouse</em>.”

“A <em>rat</em>,” Captain Fayorn corrected with a shudder as they stopped in front of another door. “Or so I thought at first. It wasn’t real. Someone was trying to rattle me.”

The sergeant grunted. “I don’t suppose you were able to apprehend the culprit?”

Fayorn flushed. “I most certainly did.”

The sergeant entered the room and emerged moments later with a ‘rat’ in each of his massive paws. Thony and Dae, held in place by the scruffs of their collars. Thony looked chagrined; Dae, indignant.

“<em>Children?</em>” Sergeant Sterevor said in amusement. “Go back to bed, sir. I’ll take care of this little rodent problem.”

Captain Fayorn glared back at him, then stalked past and went back in his room, slamming the door behind him.

The sergeant chuckled, letting go of his captives, but turning them so they both had to face him.

“So, you’re the scoundrels who disturbed Captain Fayorn’s beauty sleep.”

“Yup!” Dae said proudly. Thony groaned.

“Hunh.” Sergeant Sterevor shooed the pair of them back down the corridor.
They passed within inches of the darkened doorway where Amanita stood frozen.`,
      backblurb:`Thony’s Quest just gets more and more messed up.
Forget about finding a princess and going home to save Aldyrwald.
Now he and Amanita (who’s turned out to also be a runaway princess) are stuck trying to save all the worlds that are connected by the Fairy Wood from an army of zombies controlled by an Evil Wizard and a vengeful Dark-elf.
For allies they have the undersized mercenary Dae Goldeneyes, the unicorn Twinklestar, a pack of street-kids, and a handful of grown-ups who think they know what they’re doing (but who all got themselves captured right off).
And their only real resource is… 
their own skill at playing pranks…`
     },
    { title: `Book five of the Prankster Prince: Diary of a <del>Runaway Prince</del> Bold Questing Hero`,
      link: "PP5-P",
      image: PP5cover,
      backimage: PP5backblurb,
      shopifyProductId:   "9062122651899",// this and the line below define the book for shopify
      shopifyComponentId: "1752779005469",
      DescriptionTitle: "<em><strong>Day 20 of our journey</em></strong>",
      Description:`

So, today Amanita was in a total grump and everyone tried to avoid her while we rode along what someone has <em>finally</em> explained is called the 'Tea Road.' Apparently, that's the name because the best tea is grown in that Darjil place where Valderon Raven'sWing enchanted the whole populace, and then it's transported up here for sale around the world.

Getting hold of a <em>map</em> has been nearly as hard as getting hold of a <em>calendar</em>.

And, honestly, I could probably just ask, and someone would show me one or explain, or something. But there hasn't been much of an opportunity to ask anyone. Commander Zaja likes it quiet at meals, and nobody goes against her. And I really want to see this stuff written down, so asking while we're riding is probably not a good idea; I haven't <em>tried</em> reading while riding yet, but my stomach gets tickly in a bad way, just thinking about it.

Though Puck does it all the time, since Chillabiaen doesn't need direction any more than Twinklestar does.

Hunh. Which means if I could get over my guts, I could probably do it.

Anyways, I'm going to try talking to Daffyd in a few minutes. If we whisper, maybe I can get some more details of what's going on out of him. <em>He</em> seems to know what's going on, but when he tried to explain last night, we got those girl-guards pounding on the door and telling us to 'quiet down.'
<em><strong>Nanny-goats, all of them.</em></strong>`,
      backblurb:`It’s been a long journey already, and my Bold Quest has gotten nowhere.

I mean, I’ve managed to Save the Known Universe and all, but the only princesses that I’ve run across so far are Julanna Silversea (who is a mom and a Bard, and I don’t think pirate-princesses count for this anyways) and Amanita – and just, no.

And now I’m stuck on this other world and I don’t really know where to go next.

Luckily (???) Puck has decided I’m going to go up with him and Amanita and her brother and their warrior escort back to Amanita’s homeland. Where there probably aren’t any other princesses around.

Oh, well, at least it’s something to do.`
     },
    { title: "Book six of the Prankster Prince: A Court of Mists and Misadventures", 
      link: "PP6-P",
      image: PP6cover,
      backimage: PP6backblurb,
      shopifyProductId:   "9061450219771",// this and the line below define the book for shopify
      shopifyComponentId: "1752717898738",
      DescriptionTitle: "Thony winced.",
      Description:` “<em>NOT</em>. I'm not <em>interested</em> in anyone, guy or girl. I don't have the <em>right</em> to be <em>interested</em>,” he began.

“Your Big Quest, yadda, yadda, yadda,” Daffyd rolled his eyes. “It's to find someone to marry you, right?”

“A <em>princess</em>,” Thony clarified. “Whose <em>dad</em> will lend me his <em>army</em> to protect Aldyrwald.”

“<em>Someone</em>,” Daffyd corrected. “And how much of an 'army' do you need anyways? A dozen knights and maybe a couple hundred regular troops? Or the equivalent?”

Thony blinked. He hadn't actually thought about <em>numbers.</em>

“About that, I suppose,” he admitted, after thinking about it for a moment. “More wouldn't hurt, though.”

It wasn't likely there was anyone in the Mountain-Region who would know how to manage terribly large forces.

“You think too much,” Daffyd said as Thony ruminated on these new ideas.

And then Thony found himself being kissed without asking. <em>Again.</em>

And it was still the same problem. He didn't want to <em>hurt</em> Daffyd. He just wanted to be <em>asked</em>.
<em>(Well, and for his 'no' to be properly respected.)</em>`,
      backblurb: `Thony’s parents were overprotective enough. He ran away in the first place so that he could do what was necessary to save Aldyrwald (no matter what Mama thought).

 

He doesn’t need <em>Amanita’s</em> family to do the same thing to him, and it sure looks like that’s what’s happening. After all, he’s obviously not going to find his princess (with the father who can lend him knights and armies) hanging around in Pathremir.

 

Well, if running away worked once, he can do it again, right?


Except it’s a whole heckuvalot easier when the person who’s running away <em>with</em> you is, well, <em>better</em> at it than Amanita’s brother, Prince Daffyd. Who is a <em>total rules-follower…</em> well except for the running-away-to-avoid-being-married-off part (which Thony sympathizes with).

Daffyd is being a total drag. But how can Thony possibly leave this poor guy behind? `
     },
  ];

export  const CoIBooks = [
    { title: "Book one of Chronicles of Ilseador: The Rebel Duchess",
      link: "CoI1",
       image: CoI1cover,
      backimage: CoI1backblurb,
      shopifyProductId:   "9060935860475",// this and the line below define the book for shopify
      shopifyComponentId: "1752680733200",
      DescriptionTitle: "Meet the Rebel Duchess herself!",
      Description:`
“Lady Genevieve.” Lord Prydeen greeted her - coldly, but not correctly.

“The proper title is ‘Your Grace’, messir.”
And if she told herself that a few more times, perhaps she could dare to face him.

A wintry smile passed over the sorcerer's lips – gone as quickly as snow in the Summer. “No longer, I fear. My former master stripped you of your titles for your treasonous activities.”

“My Lord Prydeen! What passes here?” The mild voice interrupted from the direction of the stairs, but was no one Genevieve recognized.

Lord Prydeen’s voice was a curious mix of ingratiating and dismissive. “Nothing you need trouble yourself over, Your Majesty. Some rabble found her way up here, clearly to cause some trouble to you. It is my task and my privilege to safeguard Your Highness. We’ll be away momentarily.”

Gentle hands cleared away the thongs that had begun to lash her wrists. “Surely you are mistaken, my Lord Prydeen. This is no rabble, but Her Grace, the Duchess Genevieve Stellarine of Elaarwen.”

“Yes, my Lord, the so-called ‘Rebel Duchess’,” Lord Prydeen’s voice was growing impatient. “I am taking her to the castle dungeons to have out of her what she knows."`,
      backblurb:`Genevieve Stellarine inherited not only her title and duchy from her father, but Duke Aldred's vision of living in a country not ruled by an Evil Wizard. And, somehow, after eighty-three years on the throne the Old King has died, leaving behind a power struggle between his former Apprentice and his grandson, King Damien... a young man whom Genevieve saw a single time when they were both children.

As the leader of the Rebellion - the so-called Rebel Duchess - it is Genevieve's job to stay back and make sure that the new young King isn't following in his grandfather's vile footsteps before making any overtures of peace. The smart thing to do is to watch and wait...
But watching and waiting has never been Genevieve's strong suit, and with her dreams being haunted by a pair of beautiful grey eyes that she is sure belong to the young King...
What else can a brave, redheaded warrior Duchess do than check out the situation for herself?`
     },
    { title: "Book two of Chronicles of Ilseador: The King's Champion", 
      link: "CoI2",
      image: CoI2cover,
      backimage: CoI2backblurb,
      shopifyProductId:   "9061497110779",// this and the line below define the book for shopify
      shopifyComponentId: "1752718698640",
      DescriptionTitle: "Heartbreak or Hope?",
      Description:`
Sir Jason Solway, King's Champion,
has served as Genevieve's bodyguard these five years since her husband’s coronation.
A childhood friend, he has watched her decline with his own heart breaking,
carrying her fainting form away from the negotiating table
as she lost each much-wanted babe... each desperately needed potential Heir.

*

He may be able to solve their troubles... but doing so may break him, for all that he loves his monarchs well.

Sir Adam Loveress, Captain of the Royal Guard, fiancé to Jason, and closest friend to Damien,
has his own secrets that will bind their bleeding hearts... or tear them to shreds.

*

Time is running out.

Queen Genevieve's declining health may drag her beloved, soul-bonded husband into death with her.

The nobles are restive.

And there is something deeply suspicious about Queen Genevieve's attempted negotiations to restore the Lost Province of Elendria...`,
      backblurb: `“You will have no firstborn to rule after you
She will never conceive your firstborn – or at least not first.”
The last words of the Evil Wizard, Lord Prydeen, have hung over King Damien and Queen Genevieve for five years.
Five years, wherein Damien has sought to rebuild the Realm, inspiring and requiring a return to honor and noblesse oblige among his corrupt and canny noble class.
Five years, whence Genevieve has restored three of the Five Lost Provinces to Ilseador's banner, negotiating by dint of the army at her back – and her own formidable reputation as a warrior.
Five years... and ten heartbreaking miscarriages.
And then Prydeen had added those other words that either allow for a kernel of hope... or are the grindstone with which to destroy King Damien's hopeful new reign.
“You have a Champion of a problem, young king.”`
     },
    { title: "Book three of Chronicles of Ilseador: The Pirate-King", 
      link: "CoI3",
      image: CoI3cover,
      backimage: CoI3backblurb,
      shopifyProductId:   "9061543477499",// this and the line below define the book for shopify
      shopifyComponentId: "1752719544679",
      DescriptionTitle: "An Evil... STORM???",
      Description: `

One set of problems seems to have been settled...

...but the rest are just beginning when a terrible Winter storm sweeps down on Emeralsee City,
before the gathered nobles have even begun to leave the wedding celebrations.

A side-effect of Damien having brought in warm weather for the wedding... Or is it?

A malevolence seems to fill the storm that rushes in from the mountains, just as word comes in of a pirate fleet massing just outside Emeralsee Harbor.

King Damien will find himself in the magickal fight of his life as he struggles to protect his people...`,
      backblurb:`The wedding and coronation are over.
Queen Genevieve is well enough to attempt another pregnancy at last.
It’s time to proceed with the secret plan to conceive an Heir to the Throne.
But a devastating ice-storm is bearing down on the Ilseadoran capitol city of Emeralsee. King Damien suspects Evil Wizardry at work.
With all the highest nobility of the Realm trapped in Emeralsee, Damien must battle Nature Itself to save his Realm and his people from an ice-storm that seems somehow targeted to him, personally.
And that’s not even to mention the pirates converging on vulnerable, ice-locked Emeralsee…`
     },
    { title: "Book four of Chronicles of Ilseador: The Pale Sorceress",
      link: "CoI4",
      image: CoI4cover,
      backimage: CoI4backblurb,
      shopifyProductId:   "9061564645627",// this and the line below define the book for shopify
      shopifyComponentId: "1752720461487",
      DescriptionTitle:"Perhaps a Captive - Always a King",
      Description:`
“You’ll do.”
A smile that Damien was all too familiar with curled Azella’s lips. “You’ll more than do, in fact. My sources hadn’t told me how <em>handsome</em> you are. I shall quite enjoy this, I think.”

Damien tried not to roll his eyes.

“This beard...” She stroked his chin. “I assume you usually keep it a bit more trim. I usually prefer my bedmates to be cleanshaven. But then, they are usually too young to grow a proper beard. Perhaps I shall make an exception.”

“Perhaps you are making an <em>assumption,</em> lady sorceress,” Damien said dryly.

“No,” she said calmly. “You are no innocent child, Damien. You know full well the Power that is raised through sex. You will be my Apprentice. You will share my bed. And you will do whatever else I require of you.”

He looked back at Azella just as calmly. “I have sworn to my wife that I would touch no other woman in that way. And since I <em>also</em> know that the Power raised is proportional to the joy found in the doing, it won’t do you much good to compel me.”

Those blue-grey eyes sparkled. It wasn’t – quite – anger. Nor amusement. It was... challenge. Damien suspected that the sorceress rarely found something she wanted that she could not immediately bend to her will.

He suspected that was why she had wanted <em>him</em> in the first place.
“Oh, I won’t have to <em>force</em> you to make love to me, Damien. You’ll soon be <em>begging</em> to do so.”`,
      backblurb:`King Damien sacrificed himself to save his ice-bound city from pirates and sorcery.
Now he is captive to the ungentle whims of the evil sorceress, Azella the Unpitying.
Her magickal ability exceeds his own.
Damien’s only hope to win free and go home to his soul-bonded Queen and unborn child – and his still-threatened Realm to which he is also Bound – is to persuade Azella to teach him what she knows.
Azella is willing to teach him… for a price.
The question is whether Damien can give her what she wants – without following her down the path of Evil Wizardry… 
Like his grandfather before him…`
     },
    { title: "Book five of Chronicles of Ilseador: The UnCaptive King", 
      link: "CoI5",
      image: CoI5cover,
      backimage: CoI5backblurb,
      shopifyProductId:   "9061573624059",// this and the line below define the book for shopify
      shopifyComponentId: "1752721439271",
      DescriptionTitle: '<strong>“I <em>failed</em> you. We <em>all</em> failed you... Failed the <em>Realm...</em>”</strong>',
      Description:`
<strong>Adam’s words were choked out.
“Failed <em>Genevieve</em>.”</strong>

Damien’s heart, still exhilarated from his run across the country and his reclamation of Farivera, stilled from its wild beat. He had known. In some part of himself he had <em>always</em> known what he was coming home to find.

“Tomas Elsevier has her hostage, does he?”

Adam nodded without raising his head. “Her and...”

“Jason.”

Adam nodded again, eyes tightly shut, and with tears still leaking out. The Royal Guards he had brought with him down to the docks looked uncomfortably at this collapse of the stoically sarcastic man who had trained most of them. They were knights all and were not so far away from their days as squires under Adam’s sharp eye.

“And the city is under siege?” Damien asked. He hadn’t noticed any such thing as he ran down the surface of the rivers. But… he wasn’t sure he <em>would</em> have, immersed in his magick as he had been.

“What need?” Adam whispered bitterly. “Without any Alsterling to hold it, what were we to do but follow Tomas’ orders? With him holding...”

<strong><em>Damien’s arms went around Adam.
“We’ll fix it, Adam. Somehow... we’ll fix it.”</stong></em>`,
      backblurb:`Being the captive of Azella the Unpitying – who would have made him her apprentice and her spouse – has taught Damien a world of things.

How to use his magick more effectively, for one.

And just what an Evil Sorceress really does, for another.

But it’s the lessons about himself that are the hardest: that he’ll put the end before the means, to save his Realm and those he loves most dearly.

By the time Damien breaks free of Azella’s fell Keep he is, in many ways, a broken man. And no longer sure he can consider himself a ‘Good’ Sorcerer.

It will be up to Adam Loveress, Champion, mentor… and (awkwardly, inconveniently) beloved, to remind the king of who – and what – he truly is.`
     },
    { title: "Book six of Chronicles of Ilseador: A Lovely Mess",
      link: 'CoI6-HoI1',
      image: CoI6cover,
      backimage: CoI6backblurb,
      shopifyProductId:   "9061581947131",// this and the line below define the book for shopify
      shopifyComponentId: "1752722538837",
      DescriptionTitle: '“I failed you. We all failed you... Failed the Realm...”',
      Description:`
Their horses hadn't made it more than a handful of strides off of the bridge over the Sapphire when Adam made an unhappy noise and reined in tightly.

“Adam?” Damien inquired with some concern. “What's wrong?”

The tall knight looked almost greenish. “Something I ate must <em>really</em> not have agreed with me.”

Damien reached his Healer's sense out to deal with the problem. Indigestion – or even food poisoning – shouldn't take more than a moment to fix. Though they'd all been eating the same things, and Adam's iron stomach really shouldn't have been the first to react if there were an issue with improper preparation.

To the King's surprise, he could detect Adam's nausea, but no cause for it.

No, <em>more</em> than just <em>nausea...</em>

The tall knight practically slithered out of his saddle, collapsing to his knees practically <em>underneath</em> his horse in the least graceful dismount Damien had ever seen <em>anyone</em> accomplish, let alone his skilled Champion. The King hurriedly hopped off his own tall, roan palfrey to take Adam's abandoned reins and move his Champion's warhorse aside before it accidentally stepped on its rider.
Which should be unlikely, but... Adam collapsing to the ground was also <em>unlikely.</em>`,
      backblurb: `King Damien is stronger than he has ever been before after his unwilling sojourn in the Keep of Azella the Unpitying.

 

He is also more broken than ever before.

 

If he cannot discover the true source of the magick of Ilseador – to which he lays claim as its Bound King – he may never truly Heal.

 

Sir Adam Loveress is the King’s Champion – and the newly wedded husband of the Crown Prince. He is also Damien’s best friend, former mentor, and the possessor of his own mysterious magicks.

 

He saved Damien once before.

He may be the only one who can do it again:

Not because of his magick…

but because of Love.`
     },
     { title: "Book seven of Chronicles of Ilseador: Piled Higher and Deeper: Book Two of the Heart of Ilseador",
      link:"CoI-HoI2",
      image: CoI7cover,
      backimage: CoI7backblurb,
      shopifyProductId:   "9061596201211",// this and the line below define the book for shopify
      shopifyComponentId: "1752723404823",
      DescriptionTitle: 'This young woman was strong... and he shouldn\'t deny her any bit of that strength by insisting she lean on him.',
      //DescriptionSubTitle: '',
      Description: ` Her young man, however...

Damien looked up and was unsurprised to see how grim Angelos looked. But if the boy took away any of Alanna's strength when she was so vulnerable...

“I would ask for permission to call Lord Aldred out in a duel,” Angelos said, just as Damien had feared, “but it's not my place. Not yet – and... not ever unless Alanna wants it done and chooses not to do it herself.”

Damien focused again on Alanna. “Do you want to call him out yourself, Alanna? As Adam says, Aldred is too old and... canny... to accept a duel personally. And I'm going to make sure – <em>damned</em> sure – that he knows he can't turn to anyone sworn to me or Genevieve to serve that role. Likely he can find <em>someone</em>...”

“And <em>I</em> would stand for you,” the King found himself saying grimly. “Assuming you chose not to do it yourself, nor had someone else you preferred.”

Adam snorted as Alanna – and Angelos – gave Damien a startled look. “And by <em>he'll</em> do it, he means ,em>I</em> will. Since it's a Champion's <em>job</em> to stand for his king in duels. As I <em>thought</em> we established clearly a few months ago.”`,
      backblurb: `The Lady is the Lake…

 

The province of Elaarwen has proven to have Her own mind.

 

And She is demanding that King Damien Alsterling of Ilseador – and his Champion, Sir Adam Loveress – journey to the Heart of the Realm. There to accomplish some task which She has not yet revealed… or She will reject Adam’s existence… and kill him.

 

Damien has battled storms and wizards and demons. He has survived three failed coups, being captured by an evil sorceress, battling a demon, and the Realm’s attempts to eat him magickally. He has struggled to control his vast magickal powers and accepted his soul-bonded Queen bearing a child to another to save her life.

 

But Elaarwen – and Ilseador – may now be demanding more than he can give.

 

And not he, but Adam may be the one to pay the price.`,
      },
      { title: "Book eight of Chronicles of Ilseador: Assorted Proofs of Love & Power",
      link:"CoI-HoI3",
      image: CoI8cover,
      //backimage: ,     
      shopifyProductId:   "9087706497275",// this and the line below define the book for shopify
      shopifyComponentId: "1755452849677",
      DescriptionTitle: `Just as Damien accepts his loves… Azella the Unpitying makes another play for him!`,
      //DescriptionSubTitle: ``,
      Description: `At last, King Damien can let himself accept how much – how <em>passionately</em> – he adores Adam and Jason. His connection to the Realm –
       and to Elaarwen, in particular, where lies the Heart of his Realm and Power – has never been stronger.
       But Azella the Unpitying still has her dark and vile methods and the ability to summon demons. And <em>she</em> has not forgotten Damien… 
       much as he would like to forget <em>her!</em>`,
      backblurb: ``,
      },

  ];

 // Books for Knightess of the Realm
export const KotRSeries = [
  {
    title: "The-SECRETS-of-DRAGON-MOUNTAIN",
    image: SDMseriesBanner,
    books: [
      { title: "Book One of the Knightess of the Realm: An Altogether-Curious Altercation", 
        link: "KotR5-SDM1",
        miniSeries: "The SECRETS of DRAGON MOUNTAIN",
        booktagline: `The Knightess of the Realm meets DRAGONS! (Kidnapping dragons, but… well… Maybe there’s a reason?)`,
        image: KotR5cover,
        //shopifyProductId:   "9055581536507",// line and line below define for shopify
        //shopifyComponentId: "1752010975171",
        DescriptionTitle: "Something about this has a funny ring to it...",
        Description:`

Her ring – the Queen’s Ring of Taridawil that Kefen had given her for their engagement – <em>twitched</em>.

Distractedly, she rubbed at it with her other hand.

And it <em>bit</em> her.

Alarmed, Karana held up her hand in time to see the tiny golden dragon take flight, followed by a similar silver one. They dove for the caldera at the top of Dragon Mountain, dipped and cavorted around the top. The silver one settled in at the top and the gold one went skimming down to the lower slopes, scooped up a tiny bit of sand, and flew back up.

Kefen’s arm slid around her.

“You see it, too?” she asked faintly.

He nodded.

Ivan, seated on the other side, exclaimed as the tiny golden dragon flew around his side of the mountain, and scrambled to his feet. “Karana! Is that what I think it is?”

“My ring,” she confirmed.

“The Queen’s Ring,” Kefen murmured. “It was said to have magick woven into its making. Though I never heard that it ever <em>did</em> anything magickal.”

Well, besides the tiny golden dragon having somehow wrapped itself around the slender silver band sprinkled with infinitesimal diamonds that had been part of Ivan’s proposal to her as soon as the two had both been placed on her hand.
“The one you gave me is gone, too,” she told Ivan. “It... seemed to grow wings and fly off as well. There it is!”`,
        backblurb:`<p>
    Soul-bonds… were things that happened to <em>other</em> people.
</p>
<p>
    At least, they seemed to happen to people who <em>needed</em> something
    in their lives: power, wealth, safety, family… <em>agency.</em>
</p>
<p>
    They <em>didn’t</em> happen to a young woman like Karana. One who knew
    what she was doing, where she was going, and had the wherewithal – family
    support, material wealth, and personal ability – to get there.
</p>
<p>
    But Karana, first Knightess of the Realm in a century, has found her
    fated mates – both of them – in a pair of dragon-crazy young knights.
    Unfortunately, their first major mission together is going to involve
    <em>
        hunting down
    </em>
    the mythical beasts.
</p>
<p>
    If you like sweeping,<em>spicy</em>
    Epic Romantasy where love triangles don’t have to fall apart (but no one’s
    sure) and heroines who think fated mates are likely to cramp their style – 
    and<em>dragons –</em>
    then you have to read this book now!
</p>`
      },
      {title: "Book Two of the Knightess of the Realm: An All-Too-Obvious Choice", 
        link: "KotR6-SDM2",
        miniSeries: "The SECRETS of DRAGON MOUNTAIN",
        booktagline: `Captured by the very dragons they were sent to find! And offered a truly incredible opportunity…`,
        image: KotR6cover,
        //shopifyProductId:   "9055611683067",// line and line below define for shopify
        //shopifyComponentId: "1752540300924",
        DescriptionTitle: "Karana was lying still and breathing slowly, patiently letting the thicker air that the silver dragon was providing for her work its magick on her body.",
        Description:` Kefen could <em>feel</em> the changes as she improved still more.

“You are soul-bonded to her, nephew?” the strange woman said.

“To both of them,” he replied absently, not really paying attention.

The woman snorted. “And she’s carrying your child? This... may present some complications.”

Kefen tore his attention away from his loves – Karana was doing better and Ivan was watching over her. He had better pay attention to their surroundings for all three of them... and recall that they were there on a mission for King and Country.

Or at least the Lord of Wave.

“Just <em>who</em> are you?” he asked the woman as he looked at her more carefully.

“In this time and this place I am known as Faulira, dragonkeeper for Wyllirse.” She smiled affectionately up at the great creature, the softening of her expression entirely unfeigned.

She focused her dark gaze on Kefen again, and he felt the weight of Wyllirse’s dark topaz eyes on him as well.
“But in an <em>earlier</em> time and place I was known as Laurifa Saralath, Ducal-Princess and Heir to Taridawil.”`,
        backblurb:`<p>
    The reason Ivan had loved fairytales for as long as he could remember was
    because they weren’t <em>messy.</em> Not like real-life. <br/>
    <br/>
    Just as Ivan’s life started to get <em>less messy</em> – somehow, he was
    marrying <em>both</em> his true loves, with a soul-bond between all three of
    them to protect him from his fearsome father… Just as everything started to
    <em>make sense</em> and <em>feel hopeful…</em> They were kidnapped by
    dragons. <br/>
    <br/>
    Or rather by <em>one,</em> amazing, powerful <em>Golden</em> dragon. So much
    for bravely facing off against the beautiful creatures as a knight on his
    brave steed
    <em>
        (or his mule, chosen to make the steep climb up Dragon Mountain… but
        still).
    </em>
    Not that Ivan – who had dedicated himself to the Silver Dragon Goddess in an
    act of rebellion at the tender age of eight – had wanted to do any such
    thing anyways. <em></em>
</p>
<p>
    But now the dragon – and his dragonkeeper – are in possession of Ivan and
    the two people he loves more than life itself. Must Ivan make good on that
    love to rescue Kefen and Karana?
</p>
<p>
    Do you love spicy ‘why choose’ epic romantasies with utterly impossible
    options? How about truly soaring stories with tortured, anxious heroes and
    determined, fiercely independent heroines… who just
<em>have</em>
    to melt for their fated mates? Then this book is your next hot read!
</p>`
        
      },
      {title: "Book Three of the Knightess of the Realm: An Entirely-Rational(ized) Decision", 
        link: "KotR7-SDM3",
        miniSeries: "The SECRETS of DRAGON MOUNTAIN",
        booktagline: `Save Kefen – and maybe the soul-bond – or give up? Is there even a question for Karana?`,
        image: KotR7cover,
        //shopifyProductId:   "9059561996539",// line and line below define for shopify
        //shopifyComponentId: "1752542406637",
        DescriptionTitle: '“I still love you,” she murmured.',
        Description:` “I loved you <em>before</em> the soul-bond, you know.” Ivan's arms still held her tight. “This is <em>different.</em> That doesn't mean it has to be <em>bad.</em>”

Ivan looked away. “I... It's like Velerian is <em>in between</em> how I feel about everyone and everything else.” He looked down at his dragonling, who was stretched to full height with one front paw – or taloned hand – placed delicately on Ivan's belt.

“It's not your fault...” the tall knight said gently as Velerian looked at him with a certain anxiety, alternating that with giving Karana a rather suspicious look.

Karana looked between her fiancé and his dragonling speculatively. “That's... interesting. Senili is there, in ,em>my</em> head, but my connection to our soul-bond isn't blocked. It's just that I'm not picking anything up from <em>your</em> end.”`,
        backblurb:`<p>
    Karana had once dreamed of commanding her own ship.
</p>
<p>
    <br/>
    Lately those dreams seemed a lost cause. The soul-bonded fiancee of both
    Kefen, future Duke of landlocked Taridawil, and Ivan, youngest son of the
    Lord of even-more-landlocked Mountainmeadow, surely couldn’t <em>also</em>
    command a ship. <br/>
    <br/>
    An opportunity to bond with a young dragon conjured up new dreams. Flying
    with a dragon combined the freedom of commanding a ship with the honor of
    becoming one of the first dragonkeepers in a thousand years. And with the
    joy of finding the dragon-sister of Karana’s soul… much as the young woman
    had already found her Fated Mates in Kefen and Ivan. <br/>
    <br/>
    The new dreams quickly ran aground on the rocky reality of Karana’s extreme
    acrophobia and altitude sickness… Not that such things ever stopped
    her.<a name="__DdeLink__39195_3812754453"></a>Certainly not when Kefen and
    Ivan wanted to try their luck at the dragonlings’ Choice. <br/>
    <br/>
    But Kefen nearly died when one of the dragonlings attempted to bond with him
    and Ivan’s dragonling has pulled his soul away from both herself and Karana.
    Saving Kefen – <em>and</em> their soul-bond – means Karana must risk her
    life and her sanity… <br/>
    <br/>
    Explore this spicy, epic romantasy of love and loss, redemption and
    revelation in the grand finale of <em>The Secrets of Dragon Mountain!</em>
</p>`
      }
    ]
  },
  {
      title: "The Wedding of the Season",
      image: WotSseriesBanner,
      books: [
        { title: "Book four of the Knightess of the realm: An All-Too-Easy Answer",
            link:"KotRMain-4-WoS-1",
            miniSeries: "The WEDDING of the SEASON ",
            booktagline: `The actual wedding should be easy, right? Not for the Knightess of the Realm!`,
            image: KotRMain4cover,
            //shopifyProductId:   "",// this and the line below define the book for shopify
            //shopifyComponentId: "",
            //DescriptionTitle: ``,
            //DescriptionSubTitle: ``,
            //Description: ``,
            backblurb: `<p>
    Time for a wedding!
</p>
<p>
    Karana and her Companions prepare to tie the knot – just as the Goddess has
    demanded. The entire city of Wave prepares a festival to celebrate the
    marriage of their Lord’s daughter and her soul-bonded mates.
</p>
<p>
    But they must sort out the legality of triad-marriages in Kefen’s province
    of Taridawil. They have yet to hear from the famously conservative King. And
    Ivan’s fearsome father may want to weigh in as well.
</p>
<p>
    Not to mention that cultural confusions between the three young knights
    continue to confound their relationship. But at least the <em>dragons</em>
    are doing well…
</p>
<p>
    Join Karana in her wild quest for a peaceful marriage – filled with dazzling
    (and spicy) romantic love, unexpectedly exotic danger, the sweeping strokes
    of history, and the magickal powers of dragons!
</p>`,
      },
      ]
},
  {
    title: "The-HEIR’s-JOURNEY-Prequel-trilogy",
    image: HJseriesBanner,
    books: [
      { title: "Book one of the Hier's Journey(Knightess of the Realm): A Not-So-Simple Mission", 
        link: "KotR2-HJ1",
        image: KotR2cover,
        booktagline: `A relaxing trip after slaying the Evil Wizard – not! Karana can’t just decide not to love someone…`,
        miniSeries: "The HEIR’s JOURNEY Prequel trilogy",
        //shopifyProductId:   "9055385682171",// line and line below define for shopify
        //shopifyComponentId: "1751988883684",
        DescriptionTitle: 'Life just never gets less complicated, does it?',
        Description:`

<strong>Kefen sat down a bit unsteadily on one of the sofas, and blinked a couple of times.</strong>

“That... was more effective as a demonstration than an explanation,” he said faintly. An explanation? Had Ivan been <em>explaining</em> to him how kissing worked? That conversation she’d overheard on the way back from Taridawil’s border had suggested Ivan had known Kefen planned to try to kiss her...

Ivan grinned, looking well-pleased with himself, and stalked over to Karana. “Your turn, beautiful.”

Her arms came up without planning, and ended up trapped between his chest and hers. She fought her instinct to push him away, but some of the mischievous twinkle in Ivan’s eye died and he whispered, “You can say ‘no’...”

She shook her head minutely. She had agreed to it, she would see it through.

“Then try not to look so grim, beautiful. This isn’t going to hurt, you know.” Ivan quirked a half-smile.

Ivan was... much more expert at this than Kefen. That kiss in Taridawil now seemed chaste and tentative by comparison. His lips were soft against hers, but somehow demanding. Strange, fluttery feelings were making their way throughout her body, and she found herself kissing him back, her hands now clutching his tunic. Her legs didn’t seem to want to hold her up, but it didn’t matter because Ivan was not letting her fall...

“I guess you got past the grimness,”
Ivan murmured with that same wry grin as she found herself wishing he would stop talking and go back to kissing her.

“That was... rather more than I hoped for.”`,
        backblurb:`<p>
    Their kiss atop Taridawil’s tallest tower had been meaningless. Kefen can’t
    give up his future as Duke of Taridawil to marry a merchant lass. And Karana
    can’t give up her role as Head of House Metreedi.
</p>
<p>
    But the Knight-Companions – along with the third member of their trio, Ivan
    – must complete one last assignment for the King before they can move
    forward. They must escort the Princess to seek the Great Goddess’ Blessing
    on her future reign. Together. Somehow.
</p>
<p>
    Feeling jealous when Kefen pays attention to Her Highness on the journey,
    Karana suggests he go ahead to secure their ship. Kefen seems relieved to do
    so… And the move pleases Ivan, who now has Karana all to himself for a few
    days. Not that Karana really notices his reaction… though she <em>does</em>
    notice how his eyes follow Kefen as the other young man rides off...
</p>
<p>
    You’ll want to see how they work it all out in this spicy, Why Choose MMF
    epic romantasy with tortured, broody Alpharoll guys and a feisty FMC who has
    <em>Plans</em> for her own life, thank you very much!
</p>`
      },
      { title: "Book two of the Hier's Journey(Knightess of the Realm): An Entirely-Unexpected Revelation", 
        link: "KotR3-Kalapula-HJ2",
        miniSeries: "The HEIR’s JOURNEY Prequel trilogy",
        booktagline: `Washed overboard! Karana awakes on the Goddess’ Isle with Kefen beside her – but he’s mortally injured!`,
        image: KotR3cover,
        //shopifyProductId:   "9055396200699",// this and the line below define the book for shopify
        //shopifyComponentId: "1751991826604",
        DescriptionTitle: 'Goddess, please save my... love?',
        Description:`

<em><strong>“You must ask the Goddess to heal him. That’s a fatal wound, Karana. His skull is cracked and blood pools against his brain.”</em></strong>

“No!” Karana gasped, her strength quite wrung out. Kefen lay unmoving, his head in her lap, the huge purpling bruise standing out from his forehead by nearly an inch.

“And to each their time must come. Perhaps it is simply his time.”

The words were almost harsh, but the tone somehow carried a compassion that was... beyond human. As if this strange, silvery woman knew of sorrow and loss beyond what others could comprehend.

“No!” Karana cried again. “It can’t be!”

“And why not?” the strange, silvery woman asked, seeming merely curious.

“Because – because–” Words failed the knightess, and she bent her head.

“Because?”

“Because I don’t want him to die,” Karana whispered.

“We never want those we cherish to die,” the silvery woman said calmly. “And yet they all do. Why not this one? Why not now? What is he to you that you would ask the Great Goddess to save him?”

Karana shook with tears she could not shed. “He is my Bound Companion.”
<em><strong>What else could she say after all? It was Ivan’s ring on her finger. All Karana had of Kefen was an unsigned contract under review by a coterie of lawyers. And kisses and... more... and a lifetime’s worth of promises in eyes that were molten chocolate when they met hers...</em></strong>`,
        backblurb:`<p>
    Washed overboard!
</p>
<p>
    Karana wakes up on an unfamiliar beach – quickly discovering that her
    fiance, the Kefen, has washed up here as well. But she sees no sign of their
    other fiance, Ivan. And worse – Kefen’s injuries appear imminently
    life-threatening. Ivan vanishes from the young woman’s mind as she accepts
    the aid of a mysterious, silvery woman…
</p>
<p>
    Back aboard the ship, <em>Windy Osprey,</em> Ivan clings grimly to the
    railing not daring to interfere with the captain’s efforts – Karana’s uncle
    – as they seek the Goddess’s Blessed Isle in hopes of finding Ivan’s lost
    loves. The young knight knows only that he doesn’t care to live if anything
    has happened to them.
</p>
<p>
    Just when the three young knights had it all sorted out between them – the
    Great Goddess of All may intervene with Her Own Plans…
</p>
<p>
    Dive into this spicy, epic Why Choose romantasy where finding her Fated
    Mates may actually solve a few pesky problems for our feisty FMC and her
    damaged, tender, Alpharoll sweethearts.
</p>`
      },
      { title: "Book three of the Hier's Journey(Knightess of the Realm): An All-Too-Surprising Homecoming", 
        link: "KotR4-HJ3",
        miniSeries: "The HEIR’s JOURNEY Prequel trilogy",
        booktagline: `Goddesses’ Blessings may not be enough when faced with PIRATES, DRAGONS, and (foster)FATHERS!`,
        image: KotR4cover,
        //shopifyProductId:   "9055412781307",// line and line below define for shopify
        //shopifyComponentId: "1751993855138",
        DescriptionTitle: 'Not taking me seriously laddies?',
        Description:`

“Sais against a broadsword, laddie-buck?” Karana crouched down and made a come-hither gesture with her dagger.

The young pirate grinned, showing white teeth in his bronzed face, continuing to spin his strange, short weapons around in a dazzling display. He wriggled his hips at her, saying something that made about half the pirates roar with laughter. They were men, all of them, Ivan noted, all but their chief, the woman with the bandana in her hair.

Karana let her sword dangle carelessly from her fingers, and rested her dagger hand on her hip. “Is that t’best ye can do? Make pretty patterns in t’air? Or do ye use those things more often for something <em>other</em> than fighting?”

The youth’s face turned red beneath his bronze, but he didn’t make a move.

“Is he yers then, mistress? Which o’ ye gets to play wi’ his precious toys? Or are ye the type t’ <em>share?</em>” The knightess lowered her sword, and stood in a relaxed posture. She looked past the boy at the woman in the bandana – ah, Karana had marked her, too.

Ivan began to wonder nervously if she was pushing this too far, and gathered himself to rush to her aid if they should swarm her.

This last <em>suggestion</em> apparently needed no translation. The woman in the bandana looked amused, but the young pirate was scowling as his mates snickered.
Karana laughed in the pirate lad’s face and said a few words in a soft and sibilant tongue...
...and the boy lost his temper and flew at her, his metal rods whirling.`,
        backblurb:`<p>
    <em>“Pirates off the starboard stern!”</em>
</p>
<p>
    Ivan is all-too-aware that he faces his first real battle when that cry
    rings out. A real knight – no longer the academy’s ‘Golden Boy’ – he must
    face this new challenge as if it doesn’t faze him in the slightest. After
    all, his Knight-Companions – and soul-bonded fiances – already faced this
    moment when they slew the Evil Wizard… without Ivan’s help.
</p>
<p>
    But the very idea of them being in such danger – <em>again</em> – nearly
    brings the tall young man to his knees. Ivan’s stomach-cramping anxieties
    dare not surface.
</p>
<p>
    And then Karana mentions that pirates don’t attack randomly – a
    centuries-long conspiracy has undoubtedly let them know that <em>this</em>
    ship carries the Crown Princess… the Ducal-Prince… and the Head of House
    Metreedi. The attack targets Ivan’s beloveds – and the girl who’s been all
    but a younger sister.
</p>
<p>
    Pirate attacks are only the beginning of this sweeping, spicy, epic
    romantasy where the roots of ancient injuries affect decisions and
    misunderstandings between our feisty FMC and her troubled, tender fiances.
</p>`
      }
    ]
  },
  {
    title: "Prequel",
    image: SPseriesBanner,
    books: [
      { title: "A Knightess of the Realm story: The Fall of Taridawil", 
        link: "KotRP-FoT",
        miniSeries: "Prequel",
        booktagline: `Taridawil fell to the Evil Wizard Henig… leaving 12yo Kefen Saralath orphaned and alone. Or… was he?`,
        image: KotRFoTcover,
        //shopifyProductId:   "9059572842747",// this and the line below define the book for shopify
        //shopifyComponentId: "1752679915721",
        DescriptionTitle: "He doesn't want to be a knight...",
        Description:`

“But why, Father? Why do I have to stay here and learn to be a knight?”
The plea did no good, though Duke Randall looked as torn about this as did his eleven-year-old son... and within moments Kefen was left alone in the stables.

The small, dark-haired boy – no, <em>ducal-prince,</em> dammit, and that was how Kefen was going to keep his chin up – swallowed hard and began to turn back into the stall for a last measure of privacy before he had to go out there and show the world how a Saralath handled things.

But a movement to his left caught his eye.

Another boy was standing in the aisle of the stables, watching him silently. The boy was tall and golden-haired, with eyes that were almost too blue to be real. Eyes that were puzzled as he met Kefen’s own dark ones.

After a moment of looking at each other, Kefen realized the other boy was dressed as he himself was. So. Another page. And tall as he was, something about the other child nevertheless suggested to Kefen that he was also new here.

He waited, but the other boy said nothing. And when Kefen lifted an arm to rub his tears off on his sleeve and it broke their gaze, the other boy turned and began walking away.
Curious, and drawn for reasons he couldn’t have explained, Kefen followed him.`,
        backblurb:`<p>
    Before Karana won her shield… Before she spent a year alone in the forest…
</p>
<p>
    The Evil Wizard Henig destroyed Taridawil… And the younger child of Duke
    Randall went – all unwilling – to Tallspire to become a page and earn his
    shield.
</p>
<p>
    Meet Kefen and Ivan as children. Discover why Ivan fought half their class.
    Watch how they figure out what friendship means.
</p>
<p>
    And learn what <em>really</em> happened to bond them so closely together in
    this touching collection of tales filled with friendship, resilience, and
    caring.
</p>
<p>
    Set in the epic fantasy world of the <em>Knightess of the Realm Saga,</em>
    this series of not-quite-cozy stories fills in important backstory and
    elucidates the personalities of characters you’ve grown to love.
</p>`
      },
      { title: "Prequel to the Knightess of the Realm: Scaredy Cat ",
        link: "KotRP-SC",
        miniSeries: "Prequel",
        booktagline: `What does the richest man in the world do when he’s afraid to love his baby girl?`,
        image: KotRSCcover,
        //shopifyProductId:   "9059567862011",// line and line below define for shopify
        //shopifyComponentId: "1752543315865",
        DescriptionTitle: 'Not the parenting problems he anticipated...',
        Description:`
“Did you see how high I went, Uncle Andry? Did-you-did-you-did-you? I was up even higher than <em>you</em> can reach!”

Andry bent over double to sweep the small girl up in his arms. “You were, my lass. You’re getting very brave.”

“Andry, don’t encourage her,” Devin said with a sigh, and as Karana’s beaming little face fell, he cursed himself for his fumbling lack of subtlety. He should have left it to Andry, who seemed to have been <em>born</em> subtle.
You’d think that having spent every minute together that they could arrange since their mothers first had them share a cradle would have gotten some of that to rub off on Devin, but no….`,
        backblurb:`<p>
    What do you do when your three-year-old insists on sleeping in a hammock –
    two stories up from the ground?
</p>
<p>
    Devin Metreedi is the richest, most powerful man in the world. Except when
    it comes to dealing with his tiny daughter. His commanding wife gets the
    child to toe the line, but Restella spends most of her time at sea, which
    leaves Devin… not <em>alone</em> with little Karana, but in charge. Sort of.
</p>
<p>
    Devin’s worries over the obstinate little creature mingle with his lingering
    sense of loss. He lost both his parents to pirates when he was only three
    years old himself. Giving his whole heart to Karana seems to place her at
    risk of being hurt in the same way.
</p>
<p>
    Easier by far to just give orders and dictate consequences. Though his heart
    breaks a little each time his baby girl turns to someone else – someone <em>
    gentler, easier,</em>more <em>understanding</em> – for comfort.
</p>
<p>
    <em>Scaredy Cat</em> is a unique entry in the epic fantasy
    <em>
        Knightess of the Realm Saga:
    </em>
    a tender, cozy love-story about the relationship between a man and his
    little girl.
</p>`
      },
      { title: "Out of the Woods… Hopefully",
        link:"KotRP-OotW",
        miniSeries: "Prequel",
        booktagline: `<p>
    Lost and grieving, the lone survivor of a massacre… can 16-year-old Karana
    survive?
</p>
<p>
    Available in eBook only to newsletter subscribers and in limited print
    editions at book signings and kickstarters.
</p>`,
        image: KotRPOotWcover,
        //shopifyProductId:   "",// this and the line below define the book for shopify
        //shopifyComponentId: "",
        DescriptionTitle: ``,
        Description: ``,
        backblurb: `<p>
    A place of legendary danger: bandits, wild animals… The Forest of Ryylyn
    harbors all of those as well as monstrous creatures, magickal beings and
    possibly even Gates to other worlds.
</p>
<p>
    Sixteen-year-old Karana can vouch for at least the first three. On her way
    to a betrothal, her caravan was attacked by robbers and… <em>things</em>
    that certainly didn’t seem human. Her mother hid her in a secret compartment
    of their carriage to keep her out of the creatures’ sight.
</p>
<p>
    Now the only survivor of the attack, Karana discovers that the road seems to
    have vanished…
</p>
<p>
    Join Karana in her first adventure – and her most unwilling one – in this
    tale of survival, determination, and desperate, grieving loneliness.
</p>`,
      },
      { title: "Prequel to the Knightess of the Realm: A Not-So-Sacrificial Maiden", 
        link: "KotR1",
        miniSeries: "Prequel",
        booktagline: `•	What do you do when the King wants to turn you over to an Evil Wizard? Become a knight and fight the Wizard, of course!`,
        image: KotR1cover,
        //shopifyProductId:   "9051975811323",// this and the line below define the book for shopify
        //shopifyComponentId: "1751506244743",
        DescriptionTitle: `She will <em>not</em> be a "Sacrificial Maiden"!`,
        Description:`

<strong>“I cry the King’s mercy to not throw me – orphaned, alone, and helpless – into the hands of the Evil Wizard!
“I cry the chance to undo the wrongs for myself, Majesty! Allow me to train, even as do thy knights and I shall see that the Evil Wizard Henig must face Justice!”</strong>

Was it merest chance that a ray of sunshine seemed to particularly illuminate Karana in that instant? That the midnight of her hair seemed flecked with stars as dust-motes glowed about her and her green eyes sought the green eyes of the king? Was the look of startled recognition – and hope – on King Theolore’s face merely a trick of the light?
The sudden look of determination and belief on His Majesty’s face certainly was not.

“Thou shalt have thy chance, dear maiden,” King Theolore answered, to the shocked horror of the gathered onlookers. “Thou takest upon thyself a nigh impossible task, however. Thou hast only the remainder of the time allotted to us by the evil mage in which to accomplish the task of a lifetime,” he warned her. “Less than two full years from today – Midsummer’s Day.”

“For upon the end of that time,” King Theolore finished,
“whither thy preparation is complete or no, thee must face Henig in his dark citadel.
For the good of the Realm.”`,
        backblurb: `<p>
    <em>Five years ago,</em> the Evil Wizard Henig destroyed Taridawil, turning
    the prosperous province into a Black Desert.
</p>
<p>
    <em>One year ago,</em>the Evil Wizard Henig slew Karana's parents  as they
    took her to be betrothed to a lord's son.
</p>
<p>
    <em>Now,</em>seventeen-year-old Karana Metreedi has survived a brutal winter
    in the Forest of Ryylyn - a full year on her own with no human contact. But
    Henig has demanded the King turn Karana over to him or the rest of the Realm
    will repeat Taridawil's fate.
</p>
<p>
    However, the orphaned young woman has responsibilities far beyond this one
    ‘small’ Realm. Her father’s death left her as Head of the most powerful
    merchant House in the world – and the very Goddesses Themselves have
    assigned Karana a Destiny.
</p>
<p>
    She simply doesn’t have <em>time</em> to serve as a Sacrificial Maiden – not
    that it looks like a choice she gets to make!
</p>
<p>
    <a name="__DdeLink__18004_3812754453">
        Are you fond of feisty females who prefer to
    </a>
    turn Fate on its ear, challenge the status quo, and set the guys around them
    straight – all set in an exciting new fantasy world where dragons once
    roamed and might again? Then this is the book for you!
</p>`,
      }
    ]
  }
];

// backward-compatible flattened export (keeps same identifier used elsewhere)
export const KotRBooks = KotRSeries.flatMap(series => series.books);

// Books for Contemporary Romance
export const ContemporaryRomance = [
      { title: "Jack of Spades",
      link:"JoS",
      image: JoScover,
      backimage: JoSbackblurb,
      
      shopifyProductId:   "9061228642555",// this and the line below define the book for shopify
      shopifyComponentId: "1752703206829",
      backblurb:`What is the last thing a struggling artist needs?

How about major home repairs?

When Sanjana has to call in help to deal with a sinkhole that appeared in her rural backyard, she’s not expecting her former Math Team nemesis to show up… or to have turned into a hot guy…

 

<em>Small-town romance sizzles in this Kentuckiana town – but Sanjana’s backyard might not be the only thing falling apart!</em>`,
      DescriptionTitle: 'Struggling artist Sanjana Sundararaman has a sinkhole in her backyard',
      DescriptionSubTitle: '(and the hot guy who can fix it is her middle school math nemesis)',
      Description: `I crawl forwards to where I can see around the blind curve of the tunnel.

There he is, shading his eyes against the light from my headlamp. His spare headlamp.

Damn it.

I shut mine off, too, and we are drenched in a darkness more black than anything I’ve ever experienced before.

I’m frozen.

It envelopes me.

It feels like I’m breathing it in, like all those coal miners in Eastern Kentucky and their Black Lung Disease.

It’s soaking into my pores.

It’s...

“Sanjana. You can turn your lamp back on.” Kyle’s voice is calm, even, like the total blackness hasn’t bothered him one bit.

“I’ll b-b-b-blind you,” I manage to get past a tongue that seems thicker than it was a minute ago.

“I’ll be fine. I’ll shade my eyes while you turn around.”

I want to object and say that whatever he can handle, I can handle.

But it isn’t true.
I’m petrified.`
      }
  ];